import { Component } from '@angular/core';

@Component({
  selector: 'app-generic-group-details',
  standalone: false,
  templateUrl: './generic-group-details.component.html',
  styleUrl: './generic-group-details.component.scss'
})
export class GenericGroupDetailsComponent {

}
